import React from "react";
import Loading from "../../blocks/Loading";
import "./index.scss";

export default function Button(props) {
  const { type = "primary", waiting = false } = props;

  return (
    <button
      className={`reports-button ${type}`}
      onClick={props.onClick}
      disabled={props.disabled || props.waiting}
      style={props.style}
    >
      {renderContent()}
    </button>
  );

  function renderContent() {
    if (waiting) return <Loading />
    return props.children
  }
}
